import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", href: "/" },
  { label: "日本动漫", href: "/category/japanese-anime" },
  { label: "国产动漫", href: "/category/chinese-anime" },
  { label: "电视剧", href: "/category/tv-series" },
  { label: "电影", href: "/category/movies" },
  { label: "排行", href: "/category/action-adventure" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isHome && !scrolled
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className={`flex items-center gap-2 no-underline ${
              isHome && !scrolled ? "text-white" : "text-foreground-950"
            }`}
          >
            <span className="font-heading text-xl md:text-2xl font-bold tracking-wide whitespace-nowrap">
              樱花动漫
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                  location.pathname === link.href
                    ? isHome && !scrolled
                      ? "text-white font-semibold"
                      : "text-primary-500 font-semibold"
                    : isHome && !scrolled
                      ? "text-white/80 hover:text-white"
                      : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-2 md:gap-3">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
                isHome && !scrolled
                  ? "text-white/80 hover:text-white hover:bg-white/10"
                  : "text-foreground-600 hover:text-foreground-950 hover:bg-background-200"
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>

            <Link
              to="/about"
              className={`hidden md:inline-flex items-center px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? "bg-white text-foreground-950 hover:bg-white/90"
                  : "bg-primary-500 text-white hover:bg-primary-600"
              }`}
            >
              关于我们
            </Link>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
                isHome && !scrolled
                  ? "text-white/80 hover:text-white"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className={`pb-3 transition-all duration-300 ${searchOpen ? "block" : "hidden"}`}>
            <div className="relative">
              <input
                type="text"
                placeholder="搜索动漫、电视剧、电影..."
                className="w-full px-4 py-2.5 pl-10 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 transition-all"
              />
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>
        )}
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? "bg-primary-50 text-primary-500"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-4 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-white text-center transition-colors hover:bg-primary-600"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}